<div class="my_account_wrapper">
	<div class="container">
		<div class="row">
			<div class="col-lg-10 offset-lg-1 mb-5 p-md-4 p-3">
				<div class="row">
					<div class="col-lg-4 col-md-6">
						<div class="panel">
							<a class="addAvatar">
								<div
									*ngIf="user.avatar"
									class="profile-pic"
									[ngStyle]="{ 'background-image': 'url(' + user.avatar_url + ')' }"
								>
									<div class="camera_wrap">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="15.635"
											height="11.937"
											viewBox="0 0 15.635 11.937"
										>
											<path
												id="Path_8442"
												data-name="Path 8442"
												d="M-673.879,67.482a1.06,1.06,0,0,0-.759-.314h-3.632v-.925a.649.649,0,0,0-.182-.462.648.648,0,0,0-.462-.182h-4.937a.648.648,0,0,0-.462.182.649.649,0,0,0-.182.462v.925h-3.632a1.06,1.06,0,0,0-.759.314,1.06,1.06,0,0,0-.314.759v8.222a1.06,1.06,0,0,0,.314.759,1.06,1.06,0,0,0,.759.314h13.472a1.06,1.06,0,0,0,.759-.314,1.06,1.06,0,0,0,.314-.759h.016V68.242A1.06,1.06,0,0,0-673.879,67.482Zm-5.267,7.132a3.226,3.226,0,0,1-2.245.925,3.226,3.226,0,0,1-2.245-.925,3.156,3.156,0,0,1-.925-2.245,3.226,3.226,0,0,1,.925-2.245,3.156,3.156,0,0,1,2.245-.925,3.226,3.226,0,0,1,2.245.925,3.156,3.156,0,0,1,.925,2.245A3.089,3.089,0,0,1-679.145,74.614Zm4.437-5.448a.811.811,0,0,1-.722.722.809.809,0,0,1-.887-.887.812.812,0,0,1,.722-.722A.809.809,0,0,1-674.708,69.166Z"
												transform="translate(689.2 -65.6)"
											/>
										</svg>
									</div>
								</div>
								<div *ngIf="!user.avatar" class="profile-pic no_avatar addAvatar">
									<div class="svg_wrapper">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="18.767"
											height="24.093"
											viewBox="0 0 18.767 24.093"
										>
											<g
												id="Group_9074"
												data-name="Group 9074"
												transform="translate(18133 -1874.18)"
											>
												<g
													id="Group_9072"
													data-name="Group 9072"
													transform="translate(-18133 1874.18)"
													style="mix-blend-mode: lighten; isolation: isolate"
												>
													<path
														id="Path_8325"
														data-name="Path 8325"
														d="M109.221,11.383c2.588,0,4.686-2.548,4.686-5.692S113.218,0,109.221,0s-4.686,2.548-4.686,5.692S106.633,11.383,109.221,11.383Z"
														transform="translate(-100.369)"
														fill="aqua"
													/>
													<path
														id="Path_8326"
														data-name="Path 8326"
														d="M41.9,300.47c0-.192,0-.054,0,0Z"
														transform="translate(-41.895 -280.397)"
														fill="aqua"
													/>
													<path
														id="Path_8327"
														data-name="Path 8327"
														d="M308.085,301.66c0-.052,0-.364,0,0Z"
														transform="translate(-290.383 -281.437)"
														fill="aqua"
													/>
													<path
														id="Path_8328"
														data-name="Path 8328"
														d="M59.6,185.764c-.087-5.476-.8-7.036-6.274-8.024a3.844,3.844,0,0,1-5.132,0c-5.413.977-6.171,2.514-6.271,7.846-.008.435-.012.458-.013.408,0,.095,0,.27,0,.575,0,0,1.3,2.627,8.85,2.627s8.85-2.627,8.85-2.627c0-.2,0-.333,0-.426A3.514,3.514,0,0,1,59.6,185.764Z"
														transform="translate(-41.907 -165.92)"
														fill="aqua"
													/>
												</g>
												<g
													id="Group_9073"
													data-name="Group 9073"
													transform="translate(-18131.936 1874.997)"
													style="mix-blend-mode: lighten; isolation: isolate"
												>
													<path
														id="Path_8325-2"
														data-name="Path 8325"
														d="M109.221,11.383c2.588,0,4.686-2.548,4.686-5.692S113.218,0,109.221,0s-4.686,2.548-4.686,5.692S106.633,11.383,109.221,11.383Z"
														transform="translate(-100.369)"
														fill="red"
													/>
													<path
														id="Path_8326-2"
														data-name="Path 8326"
														d="M41.9,300.47c0-.192,0-.054,0,0Z"
														transform="translate(-41.895 -280.397)"
														fill="red"
													/>
													<path
														id="Path_8327-2"
														data-name="Path 8327"
														d="M308.085,301.66c0-.052,0-.364,0,0Z"
														transform="translate(-290.383 -281.437)"
														fill="red"
													/>
													<path
														id="Path_8328-2"
														data-name="Path 8328"
														d="M59.6,185.764c-.087-5.476-.8-7.036-6.274-8.024a3.844,3.844,0,0,1-5.132,0c-5.413.977-6.171,2.514-6.271,7.846-.008.435-.012.458-.013.408,0,.095,0,.27,0,.575,0,0,1.3,2.627,8.85,2.627s8.85-2.627,8.85-2.627c0-.2,0-.333,0-.426A3.514,3.514,0,0,1,59.6,185.764Z"
														transform="translate(-41.907 -165.92)"
														fill="red"
													/>
												</g>
											</g>
										</svg>
									</div>
									<!-- end"svg_wrapper -->

									<div class="camera_wrap">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="15.635"
											height="11.937"
											viewBox="0 0 15.635 11.937"
										>
											<path
												id="Path_8442"
												data-name="Path 8442"
												d="M-673.879,67.482a1.06,1.06,0,0,0-.759-.314h-3.632v-.925a.649.649,0,0,0-.182-.462.648.648,0,0,0-.462-.182h-4.937a.648.648,0,0,0-.462.182.649.649,0,0,0-.182.462v.925h-3.632a1.06,1.06,0,0,0-.759.314,1.06,1.06,0,0,0-.314.759v8.222a1.06,1.06,0,0,0,.314.759,1.06,1.06,0,0,0,.759.314h13.472a1.06,1.06,0,0,0,.759-.314,1.06,1.06,0,0,0,.314-.759h.016V68.242A1.06,1.06,0,0,0-673.879,67.482Zm-5.267,7.132a3.226,3.226,0,0,1-2.245.925,3.226,3.226,0,0,1-2.245-.925,3.156,3.156,0,0,1-.925-2.245,3.226,3.226,0,0,1,.925-2.245,3.156,3.156,0,0,1,2.245-.925,3.226,3.226,0,0,1,2.245.925,3.156,3.156,0,0,1,.925,2.245A3.089,3.089,0,0,1-679.145,74.614Zm4.437-5.448a.811.811,0,0,1-.722.722.809.809,0,0,1-.887-.887.812.812,0,0,1,.722-.722A.809.809,0,0,1-674.708,69.166Z"
												transform="translate(689.2 -65.6)"
											/>
										</svg>
									</div>
								</div>
							</a>

							<div class="form-group form_wrapper col-12 text-center">
								<input
									id="fileupload"
									class="file-input d-none"
									type="file"
									(change)="onFileChange($event)"
								/>
								<!--<a class="btn large addAvatar">Upload Avatar</a>-->
							</div>

							<form class="form_wrapper profile_form" [formGroup]="userForm" (ngSubmit)="updateProfile()">
								<div class="form-row">
									<div class="form-group grey col-md-12">
										<label class="black" for="name">First name</label>
										<input
											id="name"
											formControlName="name"
											maxlength="100"
											type="text"
											class="form-control"
											placeholder="First name"
										/>
										<div *ngIf="userFormsubmitted && uf.name.errors">
											<div class="text-danger" *ngIf="uf.name.errors.required">
												First name is required
											</div>
										</div>
									</div>
									<div class="form-group grey col-md-12">
										<label class="black" for="last_name">Last name</label>
										<input
											id="last_name"
											formControlName="last_name"
											maxlength="100"
											type="text"
											class="form-control"
											placeholder="Last name"
										/>
										<div *ngIf="userFormsubmitted && uf.last_name.errors">
											<div class="text-danger" *ngIf="uf.last_name.errors.required">
												Last name is required
											</div>
										</div>
									</div>
									<div class="form-group grey col-md-12">
										<label class="black" for="display_name">Display name</label>
										<input
											id="display_name"
											formControlName="display_name"
											maxlength="100"
											type="text"
											class="form-control"
											placeholder="Display name"
										/>
										<div *ngIf="userFormsubmitted && uf.display_name.errors">
											<div class="text-danger" *ngIf="uf.display_name.errors.required">
												Display name is required
											</div>
										</div>
									</div>
									<div class="form-group grey col-md-12">
										<label class="black" for="email">Email address</label>
										<input
											id="email"
											formControlName="email"
											maxlength="100"
											type="email"
											class="form-control"
											placeholder="Email"
										/>
										<div *ngIf="userFormsubmitted && uf.email.errors">
											<div class="text-danger" *ngIf="uf.email.errors.required">
												Email address is required
											</div>
										</div>
									</div>

									<div class="col_btn col-md-12 text-right my-auto">
										<button class="btn large blue" type="submit" [disabled]="update_loading">
											<span *ngIf="update_loading" class="spinner-border spinner-border-sm mr-1"></span>
											Update
										</button>
									</div>
								</div>
							</form>
							<!-- end form_wrapper -->
						</div>
						<!-- end panel -->
					</div>
					<!-- end col-md-4 -->

					<div class="col-lg-4 col-md-6">
						<div class="panel">

							<div class="row justify-content-center ">
								<button class="btn large col-10" (click)="confirmChangepassword()">Change Password</button>
							</div>
						</div>
						<!-- end panel -->

						<div class="panel">
							<h2 class="heading">Manage Subscription</h2>

							<div class="row" *ngIf="user && user.subscription">
								<div class="col_plan_info col-12 align-self-center">
									<div class="heading_wrap row">
										<!--<div class="col-img col-4 align-self-center">
											<div class="inner">
												<img class="img-fluid jockey-img" src="assets/images/jockeys/jockey1.png"
													alt="TRC" />
											</div>
										</div>-->
										<div class="col_current col-8 align-self-center">
											<h5>Current plan:
												<h4 *ngIf="user?.subscription && user?.subscription.plan_name">{{ user?.subscription.plan_name }}</h4>
												<h4 *ngIf="!user?.subscription || !user?.subscription.plan_name">-</h4>
											</h5>
											<div class="date" *ngIf="user?.subscription && user?.subscription.pricing_plan">
												<strong >{{ user?.subscription.pricing_plan.price | currency }}</strong
												>/{{ user?.subscription.pricing_plan.duration }}
											</div>
											<div
												class="paid-with"
												*ngIf="user?.subscription && user?.subscription.card_display_number"
											>
												<strong
													>Paid with: ****{{
														user?.subscription.card_display_number | slice: 15
													}}</strong
												>
											</div>
											<div
												class="cancelled"
												*ngIf="user?.subscription && user?.subscription.cancelled"
											>
												<strong *ngIf="user?.subscription.ends_at"
													>Subscription is cancelled and ends on
													{{  
														user?.subscription.ends_at
															| amFromUtc
															| amLocal
															| amDateFormat: 'MMMM Do YYYY'
													}}.</strong
												>
												<strong *ngIf="!user?.subscription.ends_at"
												>Subscription is cancelled.</strong
											>
											</div>
										</div>
									</div>
								</div>

								<div
									class="col_btn col-12 align-self-center text-md-right text-center"
									*ngIf="user?.subscription && !user?.subscription.cancelled"
								>
									<a class="btn large black_fill change_button" (click)="manageSubscription()"
										>Change subscription</a
									>
									<a class="btn large black" (click)="confirmCancelSubscription()"
										>Cancel subscription</a
									>
								</div>

								<div
									class="col_btn col-12 align-self-center text-md-right text-center"
									*ngIf="user?.subscription && user?.subscription.cancelled"
								>
									<a class="btn large black_fill change_button" (click)="manageSubscription()"
										>Subscribe</a
									>
								</div>
							</div>

							<div class="row" *ngIf="!user || !user.subscription">
								<div class="col_plan_info col-12 align-self-center">
									<div class="heading_wrap row">
										<div class="col-lg-7 align-self-center text-left offer_info">
											<p>Upgrade or downgrade your TRC Subscription</p>
										</div>
										<div class="col-lg-5 align-self-center offer_btn">
											<div class="inner12">
												<a class="btn large blue" (click)="manageSubscription()">Change plan</a>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="row no-gutters subscription_info py-3" *ngIf="user && user.day_pass && !user.hasPremiumSubscription" >
								<div class="form-group col-12">
									<button class="btn blue_outline" [disabled]="loading" type="button">
										<span >You have an active day pass with platinum features till {{ user?.day_pass_expiration  | amFromUtc  | amLocal | amDateFormat: 'DD MMM YYYY h:mm a'}}.</span>
									</button>
								</div>
							</div>
						</div>
						<!-- end panel -->
					</div>
					<!-- end col-md-4 panel -->

					<div class="col-lg-4">
						<div class="panel black" *ngFor="let card of cards">
							<div class="c_card">
								<div class="card_head">
									<h2 class="heading">Payment Details</h2>

									<div class="badge_wrap" *ngIf="card?.primary">
										<div class="badge light_blue">
											<span>Primary</span>
										</div>
										<!-- end badge -->
									</div>
									<!-- end badge_wrap -->

									<div (click)="changePrimaryCard(card)" class="badge_wrap" *ngIf="!card?.primary">
										<div class="badge white_outline">
											<span>Make Primary</span>
										</div>
										<!-- end badge -->
									</div>
									<!-- end badge_wrap -->
								</div>
								<!-- end card_head -->

								<div class="card_details">
									<div class="svg_wrapper">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="42.345"
											height="13.738"
											viewBox="0 0 42.345 13.738"
										>
											<g
												id="Group_9241"
												data-name="Group 9241"
												transform="translate(-458.861 -392.397)"
											>
												<g
													id="Group_9220"
													data-name="Group 9220"
													transform="translate(458.861 392.397)"
												>
													<g
														id="Group_9219"
														data-name="Group 9219"
														transform="translate(0 0)"
													>
														<path
															id="Path_8405"
															data-name="Path 8405"
															d="M56.657,65.458H53.2l2.16-13.272h3.455Z"
															transform="translate(-38.301 -51.949)"
															fill="#fff"
														/>
														<path
															id="Path_8406"
															data-name="Path 8406"
															d="M23.222,52.187l-3.294,9.128-.389-1.966h0l-1.163-5.968a1.479,1.479,0,0,0-1.639-1.2H11.291l-.064.224a12.908,12.908,0,0,1,3.614,1.518l3,11.53h3.6l5.5-13.272Z"
															transform="translate(-11.227 -51.95)"
															fill="#fff"
														/>
														<path
															id="Path_8407"
															data-name="Path 8407"
															d="M105,65.459h3.173l-2.766-13.272h-2.778a1.588,1.588,0,0,0-1.6.989L95.881,65.459h3.6l.721-1.971H104.6Zm-3.8-4.695,1.816-4.967,1.021,4.967Z"
															transform="translate(-65.828 -51.95)"
															fill="#fff"
														/>
														<path
															id="Path_8408"
															data-name="Path 8408"
															d="M78.769,54.947l.493-2.85a9.973,9.973,0,0,0-3.108-.579c-1.715,0-5.786.75-5.786,4.394,0,3.429,4.779,3.472,4.779,5.272s-4.286,1.479-5.7.343l-.514,2.98a9.678,9.678,0,0,0,3.9.75c2.358,0,5.915-1.222,5.915-4.544,0-3.451-4.822-3.772-4.822-5.272S77.291,54.132,78.769,54.947Z"
															transform="translate(-48.446 -51.518)"
															fill="#fff"
														/>
													</g>
													<path
														id="Path_8409"
														data-name="Path 8409"
														d="M19.538,59.35l-1.163-5.968a1.479,1.479,0,0,0-1.639-1.2H11.291l-.064.224a13.4,13.4,0,0,1,5.128,2.575A10.351,10.351,0,0,1,19.538,59.35Z"
														transform="translate(-11.227 -51.95)"
														fill="#fff"
													/>
												</g>
											</g>
										</svg>
									</div>
									<!-- end svg_wrapper -->

									<div class="last_digits">
										<span class="stars">****</span>
										<span class="digits">{{ card?.display_number.slice(-4) }}</span>
									</div>
									<!-- end last_digits -->
								</div>
								<!-- end card_details -->

								<div class="buttons">
									<a (click)="removeCard(card)" class="btn large white_outline">Remove</a>
								</div>
								<!-- end buttons -->
							</div>
							<!-- end card -->
						</div>
						<!-- end panel -->

						<div class="panel empty">
							<a (click)="addCard()" class="add_card">
								<div class="inner">
									<div class="svg_wrapper">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="14.53"
											height="14.53"
											viewBox="0 0 14.53 14.53"
										>
											<g
												id="Group_251"
												data-name="Group 251"
												transform="translate(12.53 -98.464) rotate(90)"
											>
												<g
													id="Group_249"
													data-name="Group 249"
													transform="translate(98.464 -2)"
												>
													<path
														id="Path_1"
														data-name="Path 1"
														d="M24.331,20.516V5.986"
														transform="translate(-17.066 -5.986)"
														fill="none"
														stroke="#000"
														stroke-miterlimit="10"
														stroke-width="2"
													/>
													<path
														id="Path_81"
														data-name="Path 81"
														d="M0,14.53V0"
														transform="translate(14.53 7.265) rotate(90)"
														fill="none"
														stroke="#000"
														stroke-miterlimit="10"
														stroke-width="2"
													/>
												</g>
											</g>
										</svg>
									</div>
									<!-- end svg_wrapper -->
									<span>Add card</span>
								</div>
								<!-- end inner -->
							</a>
						</div>
						<!-- end panel empty -->

						<div class="panel">
							<div class="download_card">
								<div class="subtitle">Download app</div>
							
								<div class="btns">
									<button (click)="navigateAppleStore()"> 
										<span>Apple</span>
										<svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M4.7832 20.1128C4.38785 19.8499 4.0368 19.5259 3.7432 19.1528C3.42667 18.7676 3.13284 18.3642 2.8632 17.9448C2.22473 17.0121 1.72462 15.9919 1.3784 14.916C0.977487 13.7508 0.768368 12.5282 0.759195 11.296C0.731612 10.1067 1.0198 8.93128 1.5944 7.8896C2.00544 7.13909 2.60909 6.51169 3.3432 6.072C4.05467 5.63082 4.8718 5.3893 5.7088 5.3728C6.0263 5.376 6.34223 5.41791 6.6496 5.4976C6.8896 5.564 7.1824 5.6728 7.5408 5.8056C7.9992 5.9808 8.2488 6.0888 8.332 6.1136C8.54411 6.19951 8.76968 6.24745 8.9984 6.2552C9.18145 6.24406 9.36208 6.20772 9.5352 6.1472C9.656 6.1056 9.8848 6.0304 10.2096 5.8888C10.5296 5.772 10.7856 5.672 10.988 5.5976C11.2747 5.5062 11.5671 5.43351 11.8632 5.38C12.1805 5.32881 12.5027 5.31485 12.8232 5.3384C13.376 5.37538 13.9205 5.49316 14.4392 5.688C15.2724 6.00948 15.9868 6.57918 16.4856 7.32C16.2705 7.45381 16.0683 7.60727 15.8816 7.7784C15.4754 8.13902 15.1294 8.56222 14.8568 9.032C14.4998 9.6734 14.3151 10.3964 14.3208 11.1304C14.3148 11.9758 14.5583 12.8043 15.0208 13.512C15.355 14.022 15.7908 14.4578 16.3008 14.792C16.5178 14.9447 16.7526 15.0704 17 15.1664C16.9 15.4784 16.7904 15.7824 16.6624 16.0824C16.3757 16.7531 16.0276 17.3959 15.6224 18.0024C15.2624 18.5272 14.9824 18.9184 14.7648 19.1768C14.4833 19.5273 14.1524 19.8351 13.7824 20.0904C13.4237 20.3277 13.0029 20.4541 12.5728 20.4536C12.282 20.4653 11.9913 20.4297 11.712 20.348C11.472 20.268 11.232 20.18 10.9992 20.0792C10.7549 19.9674 10.5031 19.8728 10.2456 19.796C9.9291 19.7132 9.60314 19.672 9.276 19.6736C8.95007 19.6732 8.62539 19.7138 8.3096 19.7944C8.05211 19.8676 7.79982 19.9579 7.5544 20.0648C7.2048 20.2104 6.9752 20.3048 6.8424 20.348C6.57148 20.4302 6.29207 20.4812 6.0096 20.5C5.56967 20.4967 5.14001 20.3667 4.772 20.1256L4.7832 20.1128ZM10.4912 4.74C9.9874 5.01019 9.41873 5.13588 8.848 5.1032C8.77427 4.52768 8.85175 3.94287 9.0728 3.4064C9.26391 2.89395 9.54514 2.41982 9.9032 2.0064C10.285 1.57253 10.7467 1.21619 11.2632 0.9568C11.7493 0.693633 12.2862 0.537858 12.8376 0.5C12.9028 1.08302 12.8315 1.67321 12.6296 2.224C12.4379 2.75659 12.1562 3.25232 11.7968 3.6896C11.4319 4.12554 10.9823 4.48289 10.4752 4.74H10.4912Z" fill="black"/>
										</svg>
									</button>
									<button (click)="navigateGoogleStore()">
										<span>Android</span>
										<svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path fill-rule="evenodd" clip-rule="evenodd" d="M1.32995 6.45743C1.16803 6.45732 1.00767 6.48912 0.85804 6.55101C0.70841 6.6129 0.572443 6.70367 0.457906 6.81812C0.343369 6.93258 0.252509 7.06849 0.190518 7.21808C0.128526 7.36767 0.0966186 7.52801 0.0966187 7.68993V12.8483C0.0966187 13.1753 0.226514 13.4889 0.457731 13.7201C0.688948 13.9513 1.00255 14.0812 1.32954 14.0812C1.65653 14.0812 1.97013 13.9513 2.20134 13.7201C2.43256 13.4889 2.56246 13.1753 2.56246 12.8483V7.68993C2.56235 7.52797 2.53034 7.36761 2.46826 7.21802C2.40617 7.06842 2.31523 6.93253 2.20063 6.81808C2.08603 6.70363 1.95001 6.61287 1.80033 6.55099C1.65065 6.48911 1.49025 6.45732 1.32829 6.45743" fill="black"/>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M3.04493 14.6875C3.04382 15.0352 3.18084 15.3691 3.42586 15.6159C3.67089 15.8626 4.00387 16.002 4.3516 16.0033H5.25327V18.735C5.24443 19.0615 5.36567 19.3782 5.59032 19.6154C5.81498 19.8525 6.12464 19.9907 6.45119 19.9996C6.77773 20.0084 7.09442 19.8872 7.33158 19.6625C7.56873 19.4378 7.70693 19.1282 7.71577 18.8016C7.71577 18.7794 7.71577 18.7572 7.71577 18.735V16.0025H9.38244V18.7333C9.38244 19.0603 9.51234 19.3739 9.74356 19.6051C9.97477 19.8363 10.2884 19.9662 10.6154 19.9662C10.9423 19.9662 11.2559 19.8363 11.4872 19.6051C11.7184 19.3739 11.8483 19.0603 11.8483 18.7333V16.0033H12.7508C13.0998 16.0033 13.4345 15.8647 13.6812 15.6179C13.928 15.3711 14.0666 15.0364 14.0666 14.6875V6.69244H3.04493V14.6925" fill="black"/>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M15.7683 6.45658C15.6064 6.45647 15.446 6.48827 15.2964 6.55016C15.1468 6.61205 15.0108 6.70282 14.8963 6.81728C14.7817 6.93174 14.6909 7.06764 14.6289 7.21723C14.5669 7.36682 14.535 7.52716 14.535 7.68908V12.8516C14.535 13.1785 14.6648 13.492 14.896 13.7231C15.1271 13.9542 15.4406 14.0841 15.7675 14.0841C16.0944 14.0841 16.4078 13.9542 16.639 13.7231C16.8701 13.492 17 13.1785 17 12.8516V7.68492C17.0001 7.52328 16.9684 7.36321 16.9066 7.21383C16.8449 7.06446 16.7543 6.92871 16.6401 6.81434C16.5258 6.69997 16.3902 6.60921 16.2409 6.54726C16.0916 6.4853 15.9316 6.45336 15.77 6.45325" fill="black"/>
											<path d="M3.04416 6.68742V14.6874C3.04405 14.8599 3.07791 15.0307 3.14381 15.1901C3.20971 15.3495 3.30636 15.4943 3.42824 15.6164C3.55011 15.7384 3.69483 15.8352 3.85413 15.9013C4.01343 15.9674 4.18419 16.0015 4.35666 16.0016H5.255V18.7333C5.255 19.0602 5.38485 19.3737 5.61599 19.6048C5.84713 19.8359 6.16062 19.9658 6.4875 19.9658C6.81438 19.9658 7.12787 19.8359 7.35901 19.6048C7.59015 19.3737 7.72 19.0602 7.72 18.7333V16.0024H9.38417V18.7316C9.38417 19.0585 9.51402 19.372 9.74516 19.6031C9.9763 19.8343 10.2898 19.9641 10.6167 19.9641C10.9436 19.9641 11.257 19.8343 11.4882 19.6031C11.7193 19.372 11.8492 19.0585 11.8492 18.7316V16.0033H12.7517C13.1007 16.0033 13.4353 15.8646 13.6821 15.6179C13.9289 15.3711 14.0675 15.0364 14.0675 14.6874V6.68742H3.05083H3.04416Z" fill="black"/>
											<path d="M1.33412 6.45326C1.17171 6.4526 1.01076 6.48404 0.860543 6.54579C0.710322 6.60754 0.573788 6.69837 0.458788 6.81306C0.343787 6.92775 0.252589 7.06404 0.190436 7.2141C0.128283 7.36415 0.0963988 7.52501 0.0966198 7.68743V12.8483C0.0966198 13.1751 0.226473 13.4886 0.457612 13.7198C0.688751 13.9509 1.00224 14.0808 1.32912 14.0808C1.656 14.0808 1.96949 13.9509 2.20063 13.7198C2.43177 13.4886 2.56162 13.1751 2.56162 12.8483V7.68743C2.56185 7.36119 2.43281 7.04815 2.20275 6.81684C1.97269 6.58553 1.66036 6.4548 1.33412 6.45326Z" fill="black"/>
											<path d="M16.9975 7.6891C16.9975 7.36244 16.8678 7.04916 16.6368 6.81818C16.4058 6.58719 16.0925 6.45743 15.7658 6.45743C15.4392 6.45743 15.1259 6.58719 14.8949 6.81818C14.6639 7.04916 14.5342 7.36244 14.5342 7.6891V12.8499C14.5342 13.1768 14.664 13.4903 14.8952 13.7215C15.1263 13.9526 15.4398 14.0824 15.7667 14.0824C16.0936 14.0824 16.4071 13.9526 16.6382 13.7215C16.8693 13.4903 16.9992 13.1768 16.9992 12.8499V7.6916L16.9975 7.6891Z" fill="black"/>
											<path d="M11.2666 1.82493L12.1266 0.254927C12.1376 0.235228 12.1445 0.213568 12.1471 0.191181C12.1497 0.168795 12.1478 0.14612 12.1416 0.124453C12.1354 0.102786 12.125 0.0825506 12.111 0.0649019C12.097 0.0472532 12.0797 0.0325374 12.06 0.0215939C12.0403 0.0106504 12.0186 0.00369393 11.9962 0.00112167C11.9738 -0.0014506 11.9512 0.000411543 11.9295 0.00660213C11.9078 0.0127927 11.8876 0.0231899 11.8699 0.0372008C11.8523 0.0512118 11.8376 0.0685623 11.8266 0.0882606L10.9591 1.67743C10.1992 1.34277 9.37786 1.16995 8.54746 1.16995C7.71707 1.16995 6.89577 1.34277 6.13579 1.67743L5.26746 0.094094C5.24591 0.0543114 5.20944 0.0247182 5.16607 0.0118251C5.1227 -0.00106806 5.07599 0.00379457 5.03621 0.0253435C4.99642 0.0468923 4.96683 0.0833625 4.95394 0.12673C4.94105 0.170098 4.94591 0.216811 4.96746 0.256594L5.82746 1.8266C4.99221 2.23237 4.28557 2.8614 3.78579 3.64402C3.286 4.42665 3.01257 5.33233 2.99579 6.26077H14.095C14.0781 5.33257 13.805 4.42709 13.3059 3.64431C12.8067 2.86154 12.101 2.2319 11.2666 1.82493ZM6.4858 3.7866C6.48845 3.84926 6.4784 3.91182 6.45625 3.9705C6.4341 4.02918 6.4003 4.08277 6.3569 4.12805C6.3135 4.17333 6.26138 4.20936 6.20369 4.23398C6.146 4.25859 6.08393 4.27128 6.02121 4.27128C5.95849 4.27128 5.89642 4.25859 5.83873 4.23398C5.78104 4.20936 5.72892 4.17333 5.68552 4.12805C5.64212 4.08277 5.60832 4.02918 5.58617 3.9705C5.56402 3.91182 5.55397 3.84926 5.55663 3.7866C5.55397 3.72393 5.56402 3.66138 5.58617 3.6027C5.60832 3.54402 5.64212 3.49043 5.68552 3.44515C5.72892 3.39987 5.78104 3.36384 5.83873 3.33922C5.89642 3.31461 5.95849 3.30192 6.02121 3.30192C6.08393 3.30192 6.146 3.31461 6.20369 3.33922C6.26138 3.36384 6.3135 3.39987 6.3569 3.44515C6.4003 3.49043 6.4341 3.54402 6.45625 3.6027C6.4784 3.66138 6.48845 3.72393 6.4858 3.7866ZM11.5391 3.7866C11.5391 3.91015 11.4901 4.02863 11.4027 4.116C11.3153 4.20336 11.1969 4.25243 11.0733 4.25243C10.9498 4.25243 10.8313 4.20336 10.7439 4.116C10.6565 4.02863 10.6075 3.91015 10.6075 3.7866C10.6075 3.66305 10.6565 3.54457 10.7439 3.45721C10.8313 3.36984 10.9498 3.32077 11.0733 3.32077C11.1969 3.32077 11.3153 3.36984 11.4027 3.45721C11.4901 3.54457 11.5391 3.66305 11.5391 3.7866Z" fill="black"/>
										</svg>
									</button>
								</div>
							</div>
						</div>
					</div>
					<!-- end col-md-4 -->
				</div>
				<!-- end row -->
			</div>
			<!-- end panel -->
		</div>
		<!-- end row -->
	</div>
	<!-- container -->
</div>
<!-- my_account_wrapper -->
